import { QueryFunctionContext } from '@tanstack/react-query'
import { DesignVariationsService } from 'services/DesignVariationsService'

export const queryDesignVariations = async ({
  queryKey,
}: QueryFunctionContext<DesignVariations.QueryKey>): Promise<DesignVariations.DesignVariationResponse[]> => {
  const [_, input] = queryKey

  const offset = 0
  // just get all at once
  const limit = 50000
  const query = {
    ...input,
    offset,
    limit,
  }

  const response = await DesignVariationsService.getDesignVariations(query)

  return response.results.content
}
